import React, { useState } from "react";
import residentialImg from "../img/envision/valuefirst/valuefirst.JPG";

const FirstValueBanner = () => {
  const [isTextVisible, setIsTextVisible] = useState(false);

  // Function to toggle visibility
  const toggleTextVisibility = () => {
    setIsTextVisible(!isTextVisible);
  };

  return (
    <section>
      <div className="container-fluid" style={{ padding: "0px", overflow: "hidden" }}>
        <div className="row">
          <div className="col-lg-12">
            {/* Text that can be shown/hidden with fade effect */}
            <div
              style={{
                background: "#068699",
                padding: "10px 20px",
                textAlign: "center",
                color: "#fff",
                fontSize: "1.5rem",
                fontWeight: "600",
                position: "absolute",
                top: "20px",
                width: "100%",
                zIndex: "1",
                opacity: isTextVisible ? 1 : 0, // Fade in/out using opacity
                transition: "opacity 1s ease-in-out", // Smooth transition for opacity
              }}
            >
              This is the text above the banner. You can add any message here.
            </div>
            <section
              className="breadcumb"
              aria-label="breadcumb"
              style={{
                backgroundImage: `url(${residentialImg})`,
                height: "750px", // Increased height for image
                backgroundSize: "cover", // Ensure the image covers the section
                backgroundPosition: "center", // Center the image
                position: "relative",
              }}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="main">
                      <div className="bread">
                        <div
                          className="bread-title"
                          style={{
                            fontSize: "2.5rem",
                            fontWeight: "700",
                            letterSpacing: "2px",
                            display: "block",
                            marginTop: "100px",
                          }}
                        >
                          Navigating with
                          ValuesFIRST
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Button to toggle the text visibility */}
      <button
        onClick={toggleTextVisibility}
        style={{
          position: "absolute",
          top: "10px",
          left: "20px",
          background: "#068699",
          color: "#fff",
          border: "none",
          padding: "10px 20px",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        {isTextVisible ? "Hide Text" : "Show Text"}
      </button>
    </section>
  );
};

export default FirstValueBanner;
